import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import LayoutComponent from './components/AppLayout';
import { Landing } from './pages/Login/Landing';
import { MyProfile } from './pages/MyProfile';
import { UserAdmin } from './pages/Admin/UserAdmin';
import { YouthDashboard } from './pages/Youth/YouthDashboard';
import { SchoolCoordinatorDashboard } from './pages/Youth/SchoolCoordinatorDashboard';
import { AdminDashboard } from './pages/Admin/AdminDashboard';
import { LogoutLoader } from './pages/Login/Logout';
import { SchoolAdmin } from './pages/Admin/SchoolAdmin';
import { RegionAdmin } from './pages/Admin/RegionAdmin';
import { Registration } from './pages/Login/Registration';
import { RedirectToDash } from './pages/RedirectToDash';
import { appConfig } from './services/config.service';
import { withProtectedRoute } from './pages/Login/ProtectedRoute';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { CaseDetail } from './pages/Admin/CaseDetail';
import { DownloadUserData } from './pages/Admin/DownloadUserData';
import { ManageSponsoredAds } from './pages/Admin/ManageSponsoredAds';

export interface IApplicationProps { }

const Application: React.FunctionComponent<IApplicationProps> = () => {
  const ProtectedLayoutComponent = withProtectedRoute(LayoutComponent);
  const ProtectedRedirectToDash = withProtectedRoute(RedirectToDash);
  const ProtectedMyProfile = withProtectedRoute(MyProfile);
  const ProtectedUserAdmin = withProtectedRoute(UserAdmin);
  const ProtectedSchoolAdmin = withProtectedRoute(SchoolAdmin);
  const ProtectedRegionAdmin = withProtectedRoute(RegionAdmin);
  const ProtectedYouthDashboard = withProtectedRoute(YouthDashboard);
  const ProtectedSchoolCoordinatorDashboard = withProtectedRoute(SchoolCoordinatorDashboard);
  const ProtectedAdminDashboard = withProtectedRoute(AdminDashboard);
  const ProtectedCaseDetail = withProtectedRoute(CaseDetail);
  const ProtectedDownloadUserData = withProtectedRoute(DownloadUserData);
  const ProtectedManageSponsoredAds = withProtectedRoute(ManageSponsoredAds);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Auth0Provider
          domain={appConfig.AUTH0_DOMAIN}
          clientId={appConfig.AUTH0_CLIENTID}
          useRefreshTokens={true}
          useRefreshTokensFallback={false}
          authorizationParams={{
            redirect_uri: appConfig.AUTH0_REDIRECTURI,
            audience: appConfig.AUTH0_AUDIENCE
          }}
        >
          <Routes>
            <Route path="" element={<ProtectedLayoutComponent />} >
              <Route path="/" element={<ProtectedRedirectToDash />} />
              <Route path="redirect" element={<ProtectedRedirectToDash />} />
              <Route path="profile" element={<ProtectedMyProfile />} />
              <Route path="useradmin" element={<ProtectedUserAdmin />} />
              <Route path="schooladmin" element={<ProtectedSchoolAdmin />} />
              <Route path='regionadmin' element={<ProtectedRegionAdmin />} />
              <Route path='schoolcoordinatordashboard/:schoolId?' Component={ProtectedSchoolCoordinatorDashboard} element={<ProtectedSchoolCoordinatorDashboard />} />
              <Route path="/youthdashboard/:id?" Component={ProtectedYouthDashboard} element={<ProtectedYouthDashboard />} />
              <Route path='admindashboard' element={<ProtectedAdminDashboard />} />
              <Route path='casedetail/:caseType?/:region?/:competency?/:searchQuery?/:assigned?' Component={ProtectedCaseDetail} element={<ProtectedCaseDetail />} />
              <Route path='downloaduserdata' element={<ProtectedDownloadUserData />} />
              <Route path='managesponsoredads' element={<ProtectedManageSponsoredAds />} />
            </Route>
            <Route path='registration' element={<Registration />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/logout" element={<LogoutLoader />} />
          </Routes>
        </Auth0Provider>
      </BrowserRouter>
    </Provider>
  );
};

export default Application;
